import { ReactNode, useEffect } from 'react';

const useScrollToTopOnMount = (children: ReactNode) => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [children]);
};

export default useScrollToTopOnMount;
